import React, { useEffect, useState } from 'react';
import { reducedMotion } from '../../utils/zoom';
import styles from './agentChat.module.css';

/**
 * WHILE AN ANSWER IS ON ITS WAY (DESIGN_SYSTEM §6.11) — not three bouncing dots: one short shimmering line that fades
 * between a few honest phrases, every PHRASE_MS, and stays on the last one.
 *
 * Honest means it never claims work that may not be happening ("checking the calendar" would be a lie on a question
 * about opening hours), and it makes no promise about time ("almost there" is false on a slow answer).
 *
 * A screen reader hears ONE sentence, once: the live region holds the first phrase and never changes; the cycling
 * phrase is hidden from it. With reduced motion the line is still: the first phrase, no shimmer, no fades.
 */
export const PHRASES = [
  ['agent.thinking1', 'Thinking…'],
  ['agent.thinking2', 'Checking the details…'],
  ['agent.thinking3', 'Putting the answer together…'],
];
export const PHRASE_MS = 1600;
export const FADE_MS = 220;

export default function ThinkingLine({ t }) {
  const [still] = useState(() => reducedMotion());
  const [i, setI] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (still || i >= PHRASES.length - 1) return undefined;
    const out = setTimeout(() => setFading(true), PHRASE_MS - FADE_MS);
    const next = setTimeout(() => { setFading(false); setI(i + 1); }, PHRASE_MS);
    return () => { clearTimeout(out); clearTimeout(next); };
  }, [i, still]);

  const say = ([key, fallback]) => t(key, { defaultValue: fallback });
  const cls = [styles.thinkingPhrase, still ? '' : styles.thinkingShimmer, fading ? styles.thinkingFading : ''].filter(Boolean).join(' ');
  return (
    <div className={styles.thinking} role="status" aria-live="polite">
      <span className={styles.srOnly}>{say(PHRASES[0])}</span>
      <span key={i} className={cls} aria-hidden="true" data-testid="agent-thinking-phrase">{say(PHRASES[i])}</span>
    </div>
  );
}
